import { render, staticRenderFns } from "./QwTag.vue?vue&type=template&id=075fe02b&scoped=true"
import script from "./QwTag.vue?vue&type=script&lang=js"
export * from "./QwTag.vue?vue&type=script&lang=js"
import style0 from "./QwTag.vue?vue&type=style&index=0&id=075fe02b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075fe02b",
  null
  
)

export default component.exports